import { DrawerReturnTypeWithPayload } from '../../../hooks/useDrawer'
import { SidebarTypeUnion } from '../constants'

export const defaultSideDrawer: DrawerReturnTypeWithPayload<{
  type: SidebarTypeUnion
}> = {
  state: {
    visible: false,
    title: '',
    width: 420,
    payload: { type: '' as SidebarTypeUnion },
    onClose: () => undefined
  },
  actions: {
    close: () => undefined,
    open: () => undefined,
    setState: () => undefined
  }
}

export const DEFAULT_CHAT_LIST_LIMIT = 20
